import React from 'react';
import { NavLink } from 'react-router-dom';
// import styles from './Slidebar.module.css';
import logo from '../../assets/img/logo.png';
import { useLocation } from 'react-router-dom';
import { myRole } from '../../services/roleServices';
import { useSidebar } from '../../contexts/SidebarContext';

const Sidebar = () => {
  const { collapsed } = useSidebar();
  const location = useLocation();

  // Helper function to determine if the link is active
  const isLinkActive = (path) => location.pathname === path;

  // Class management for active state on main sidebar link

  // Sidebar - Transaction Satus
  const transactionStatus = isLinkActive('/transactionStatus')

  // Sidebar - PDF Generation - Payment Receipt
  const paymentReceiptClass = isLinkActive('/paymentReceiptReceived') || isLinkActive('/paymentReceiptGenerated') || isLinkActive('/prCurrencyType') || isLinkActive('/prEventType') || isLinkActive('/prOccupancyType') || isLinkActive('/prPaymentType') || isLinkActive('/prRegistrationType') || isLinkActive('/prRegistrationCategory');
  const paymentReceiptClassMulti = isLinkActive('/prCurrencyType') || isLinkActive('/prEventType') || isLinkActive('/prOccupancyType') || isLinkActive('/prPaymentType') || isLinkActive('/prRegistrationType') || isLinkActive('/prRegistrationCategory');

  // Sidebar - PDF Generation - Invoice Receipt
  const invoiceReceiptClass = isLinkActive('/invoiceReceiptReceived') || isLinkActive('/invoiceReceiptGenerated') || isLinkActive('/invoiceUsBank') || isLinkActive('/invoiceInBank') || isLinkActive('/invoiceRegType');
  const invoiceReceiptClassMulti = isLinkActive('/invoiceUsBank') || isLinkActive('/invoiceInBank') || isLinkActive('/invoiceRegType');

  //sidebar - PDF Generation - Abstract Receipt
  const adminAbstractReceiptClass = isLinkActive('/abstractReceipt') || isLinkActive('/abstractType') || isLinkActive('/abCategory') ;
  const programManagerClassMulti = isLinkActive('/pendingProgramManager') || isLinkActive('/approvedProgramManager');
  const reviewersClassMulti = isLinkActive('/allReviewers') || isLinkActive('/pendingReviewers') || isLinkActive('/approvedReviewers');

  //General Configuration - event setup - Abstract Acceptance
  const defaultSetupClass = isLinkActive('/esSubjectType') || isLinkActive('/esSeriesType') || isLinkActive('/esVenue') || isLinkActive('/esSubdomainType') || isLinkActive('/esCountries');


  //accommodation status
  const accommodationStatusClass = isLinkActive('/paidAccommodation') || isLinkActive('/freeAccommodation');
  //event setup
  const eventSetupClass = isLinkActive('/conferenceEvent') || isLinkActive('/webinarEvent');


  //refund status
  const refundStatusClass = isLinkActive('/refundApproved') || isLinkActive('/refundPending');

  //revenuestatus
  const revenueStatusClass = isLinkActive('/revenueAll') || isLinkActive('/revenueConference') || isLinkActive('/revenueWebinar');

  //paayment receipt Form
  const paymentReceipt = isLinkActive('/paymentReceipt')

  //invoice receipt form
  const invoiceReceipt = isLinkActive('/invoiceReceipt')
  //refund form
  const refund = isLinkActive('/refund')

  //Accommodation form
  const accommodation = isLinkActive('/accommodation')

  //conferenceleads - leadforms - revenueforms
  const leadsFormsClass = isLinkActive('/abstract') || isLinkActive('/brochure') || isLinkActive('/contact') || isLinkActive('/pastconfProceedingsLists');
  const revenueFormsClass = isLinkActive('/registration') || isLinkActive('/selfRegistration') || isLinkActive('/paypalTransactions') || isLinkActive('/razorpayTransactions');

  //event form class
  // const receiptGenerationClass = isLinkActive('/paymentreceipt') || isLinkActive('/invoicegeneration');

  const abstractReceiptClass = isLinkActive('/abstractReceipt');
  const abstractConfigClass = isLinkActive('/programManager') || isLinkActive('/abReviewers');

  //conferenceleads - leadforms - revenueforms
  const emleadsFormsClass = isLinkActive('/emabstract') || isLinkActive('/embrochure') || isLinkActive('/emcontact') || isLinkActive('/empastconfProceedingsLists');
  const emrevenueFormsClass = isLinkActive('/emregistration') || isLinkActive('/emselfRegistration');



  // dasboard
  const dashboardClass = isLinkActive('/dashboard');

  // user creation 
  const cmsUserCreationFormsClass = isLinkActive('/cmsuser');

  //seo config
  const seoConfigClass = isLinkActive('/metaTags') || isLinkActive('/seoContextPage');

  //finance
  const revenueClass = isLinkActive('/revenueAll')

  //management
  const mgmtPaymentReceiptClass = isLinkActive('/mgmtPaymentReceiptReceived') || isLinkActive('/mgmtPaymentReceiptGenerated') || isLinkActive('/mgmtPrCurrencyType') || isLinkActive('/mgmtPrEventType') || isLinkActive('/mgmtPrOccupancyType') || isLinkActive('/mgmtPrPaymentType') || isLinkActive('/mgmtPrRegistrationType') || isLinkActive('/mgmtPrRegistrationCategory');
  const mgmtpaymentReceiptClassMulti = isLinkActive('/mgmtPrCurrencyType') || isLinkActive('/mgmtPrEventType') || isLinkActive('/mgmtPrOccupancyType') || isLinkActive('/mgmtPrPaymentType') || isLinkActive('/mgmtPrRegistrationType') || isLinkActive('/mgmtPrRegistrationCategory');

  const mgmtInvoiceReceiptClass = isLinkActive('/mgmtInvoiceReceiptReceived') || isLinkActive('/mgmtInvoiceReceiptGenerated') || isLinkActive('/mgmtInvoiceUsBank') || isLinkActive('/mgmtInvoiceInBank') || isLinkActive('/mgmtInvoiceRegType');
  const mgmtInvoiceReceiptClassMulti = isLinkActive('/mgmtInvoiceUsBank') || isLinkActive('/mgmtInvoiceInBank') || isLinkActive('/mgmtInvoiceRegType');

  //accommodation status
  const mgmtAccommodationStatusClass = isLinkActive('/mgmtPaidAccommodation') || isLinkActive('/mgmtFreeAccommodation');

  const mgmtAccommodationClass = isLinkActive('/mgmtStagingAccommodation') || isLinkActive('/mgmtVerifiedAccommodation') || isLinkActive('/mgmtPendingAccommodation') || isLinkActive('/mgmtCancelledAccommodation') || isLinkActive('/accommodationSetup');;
  const mgmtAccommodationSetupClassMulti = isLinkActive('/accommodationSetup');

  //refund status
  const mgmtRefundStatusClass = isLinkActive('/mgmtRefundApproved') || isLinkActive('/mgmtRefundPending');

  //revenuestatus
  const mgmtRevenueStatusClass = isLinkActive('/mgmtRevenueAll') || isLinkActive('/mgmtRevenueConference') || isLinkActive('/mgmtRevenueWebinar');

  // Sidebar - Transaction Satus
  const mgmtTransactionStatus = isLinkActive('/mgmtTransactionStatus');
  const mgmtPaypalTransactions = isLinkActive('/mgmtPaypalTransactions');

  return (
    <nav id="sidebar" className={`sidebar js-sidebar ${collapsed ? 'collapsed' : ''}`} >
      <div className="sidebar-content js-simplebar" data-simplebar="init">
        <div className="simplebar-wrapper" style={{ margin: '0' }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div className="simplebar-offset" style={{ right: '0', bottom: '0' }}>
              <div className="simplebar-content-wrapper" tabIndex="0" role="region" aria-label="scrollable content" style={{ height: '100%', overflow: 'hidden scroll' }} >
                <div className="simplebar-content" style={{ padding: '0' }}>
                  <NavLink className="sidebar-brand" to="index.html">
                    <img src={logo} width="200px" alt="Scientex Conferences" />
                  </NavLink>
                  <ul className="sidebar-nav">
                    {myRole() === 'admin' ? (
                      <>
                        <li className="sidebar-item">
                          <NavLink className="sidebar-link" to="/dashboard">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-sliders align-middle" > <line x1="4" y1="21" x2="4" y2="14"></line> <line x1="4" y1="10" x2="4" y2="3"></line> <line x1="12" y1="21" x2="12" y2="12"></line> <line x1="12" y1="8" x2="12" y2="3"></line> <line x1="20" y1="21" x2="20" y2="16"></line> <line x1="20" y1="12" x2="20" y2="3"></line> <line x1="1" y1="14" x2="7" y2="14"></line> <line x1="9" y1="8" x2="15" y2="8"></line> <line x1="17" y1="16" x2="23" y2="16"></line> </svg>
                            <span className="align-middle">Dashboard</span>
                          </NavLink>
                        </li>
                        <li className="sidebar-header">Revenue Management</li>
                        <li className={`sidebar-item ${transactionStatus ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/transactionStatus">
                            <i className="align-middle me-2 fas fa-fw fa-list"></i>
                            <span className="align-middle">Transaction Status</span>
                          </NavLink>
                        </li>
                        <li className={`sidebar-item ${revenueStatusClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#revenueStatus" data-bs-toggle="collapse"
                            className={`sidebar-link ${revenueStatusClass ? 'active' : ''}`}
                            aria-expanded={revenueStatusClass ? 'true' : 'false'}>

                            <i className="align-middle me-2 fas fa-fw fa-dollar-sign"></i>
                            <span className="align-middle">Revenue Status</span>
                          </NavLink>
                          <ul id="revenueStatus" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${revenueStatusClass ? 'show' : ''}`}
                          >

                            <li className={`sidebar-item ${isLinkActive('/revenueAll') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/revenueAll" > All Revenue </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/revenueConference') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/revenueConference" > Conference Revenue </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/revenueWebinar') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/revenueWebinar" > Webinar Revenue </NavLink>
                            </li>
                          </ul>
                        </li>
                        <li className={`sidebar-item ${refundStatusClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#refundStatus" data-bs-toggle="collapse"
                            className={`sidebar-link ${refundStatusClass ? 'active' : ''}`}
                            aria-expanded={refundStatusClass ? 'true' : 'false'}>

                            <i className="align-middle me-2 fas fa-fw fa-directions"></i>
                            <span className="align-middle">Refund Status</span>
                          </NavLink>
                          <ul id="refundStatus" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${refundStatusClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/refundApproved') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/refundApproved" > Approved Refunds </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/refundPending') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/refundPending" > Pending Refunds </NavLink>
                            </li>
                          </ul>
                        </li>
                        <li className="sidebar-header">Conference Management</li>
                        <li className={`sidebar-item ${accommodationStatusClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#conferenceManagement" data-bs-toggle="collapse"
                            className={`sidebar-link ${accommodationStatusClass ? 'active' : ''}`}
                            aria-expanded={accommodationStatusClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-directions"></i>
                            <span className="align-middle">Accommodation Status</span>
                          </NavLink>
                          <ul id="conferenceManagement" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${accommodationStatusClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/paidAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/paidAccommodation" > Paid </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/freeAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/freeAccommodation" > Free </NavLink>
                            </li>
                          </ul>
                        </li>

                         <li className="sidebar-header">Event Management</li>
                        <li className={`sidebar-item ${eventSetupClass ? 'active' : ''}`}>
                        <NavLink data-bs-target="#eventSetupClass" data-bs-toggle="collapse"
                          className={`sidebar-link ${eventSetupClass ? 'active' : ''}`}
                          aria-expanded={ eventSetupClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle"> Event Setup </span>        
                        </NavLink>
                        <ul id="eventSetupClass" data-bs-parent="#sidebar"
                          className={`sidebar-dropdown list-unstyled collapse ${eventSetupClass ? 'show' : ''}`}
                        >
                          <li className={`sidebar-item ${isLinkActive('/conferenceEvent') ? 'active' : ''}`}>
                            <NavLink className="sidebar-link" to="/conferenceEvent" > Conference Event </NavLink>
                          </li>
                          <li className={`sidebar-item ${isLinkActive('/webinarEvent') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/webinarEvent"> Webinar Event </NavLink>
                          </li>
                        </ul>
                        </li>

                        <li className="sidebar-header">Conference Leads</li>
                        <li className={`sidebar-item ${leadsFormsClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#conferenceLeads" data-bs-toggle="collapse"
                            className={`sidebar-link ${leadsFormsClass ? 'active' : ''}`}
                            aria-expanded={leadsFormsClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle">Leads Forms</span>
                          </NavLink>
                          <ul id="conferenceLeads" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${leadsFormsClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/abstract') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/abstract" > Abstract </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/brochure') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/brochure" > Brochure </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/contact') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/contact" > Contact </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/pastconfProceedingsLists') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/pastconfProceedingsLists" > Proceedings Lists </NavLink>
                            </li>
                          </ul>
                        </li>
                        <li className={`sidebar-item ${revenueFormsClass ? 'active' : ''}`}>
                        <NavLink data-bs-target="#RevenueLeads" data-bs-toggle="collapse"
                          className={`sidebar-link ${revenueFormsClass ? 'active' : ''}`}
                          aria-expanded={ revenueFormsClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle">Revenue Forms</span>        
                        </NavLink>
                        <ul id="RevenueLeads" data-bs-parent="#sidebar"
                          className={`sidebar-dropdown list-unstyled collapse ${revenueFormsClass ? 'show' : ''}`}
                        >
                        <li className={`sidebar-item ${isLinkActive('/registration') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/registration" > Registration </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/selfRegistration') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/selfRegistration" > Self Registration </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/paypalTransactions') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/paypalTransactions" > Paypal Transactions </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/razorpayTransactions') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/razorpayTransactions" > Razorpay Transactions </NavLink>
                        </li>
                        </ul>
                      </li>

                        <li className="sidebar-header">PDF Generation</li>
                        <li className={`sidebar-item ${paymentReceiptClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#paymentReceipt" data-bs-toggle="collapse"
                            className={`sidebar-link ${paymentReceiptClass ? 'active' : ''}`}
                            aria-expanded={paymentReceiptClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Payment Receipt</span>
                          </NavLink>
                          <ul id="paymentReceipt" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${paymentReceiptClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/paymentReceiptReceived') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/paymentReceiptReceived" > Received Receipt </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/paymentReceiptGenerated') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/paymentReceiptGenerated" > Generated Receipt </NavLink>
                            </li>
                            <li className="sidebar-item">
                              <NavLink
                                data-bs-target="#paymentReceiptMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${paymentReceiptClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={paymentReceiptClassMulti ? 'true' : 'false'}
                              > Configuration </NavLink>
                              <ul id="paymentReceiptMulti" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${paymentReceiptClassMulti ? 'show' : ''}`}
                              >
                                <li className={`sidebar-item ${isLinkActive('/prCurrencyType') ? 'active' : ''}`}>
                                  <NavLink to="/prCurrencyType"
                                    className={`sidebar-link ${isLinkActive('/prCurrencyType') ? 'active' : ''}`}
                                  > Currency Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/prEventType') ? 'active' : ''}`}>
                                  <NavLink to="/prEventType"
                                    className={`sidebar-link ${isLinkActive('/prEventType') ? 'active' : ''}`}
                                  > Event Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/prOccupancyType') ? 'active' : ''}`}>
                                  <NavLink to="/prOccupancyType"
                                    className={`sidebar-link ${isLinkActive('/prOccupancyType') ? 'active' : ''}`}
                                  > Occupancy Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/prPaymentType') ? 'active' : ''}`}>
                                  <NavLink
                                    to="/prPaymentType"
                                    className={`sidebar-link ${isLinkActive('/prPaymentType') ? 'active' : ''}`}
                                  > Payment Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/prRegistrationType') ? 'active' : ''}`}>
                                  <NavLink
                                    to="/prRegistrationType"
                                    className={`sidebar-link ${isLinkActive('/prRegistrationType') ? 'active' : ''}`}
                                  > Registration Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/prRegistrationCategory') ? 'active' : ''}`}>
                                  <NavLink
                                    to="/prRegistrationCategory"
                                    className={`sidebar-link ${isLinkActive('/prRegistrationCategory') ? 'active' : ''}`}
                                  > Registration Category </NavLink>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>

                        <li className={`sidebar-item ${invoiceReceiptClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#invoice" data-bs-toggle="collapse"
                            className={`sidebar-link ${invoiceReceiptClass ? 'active' : ''}`}
                            aria-expanded={invoiceReceiptClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Invoice Receipt</span>
                          </NavLink>
                          <ul id="invoice" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${invoiceReceiptClass ? 'show' : ''}`}
                          >

                            <li className={`sidebar-item ${isLinkActive('/invoiceReceiptReceived') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/invoiceReceiptReceived"> Received Receipt </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/invoiceReceiptGenerated') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/invoiceReceiptGenerated"> Generated Receipt </NavLink>
                            </li>
                            <li className="sidebar-item">
                              <NavLink data-bs-target="#invoiceReceiptMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${invoiceReceiptClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={invoiceReceiptClassMulti ? 'true' : 'false'}
                              >
                                Configuration </NavLink>
                              <ul id="invoiceReceiptMulti" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${invoiceReceiptClassMulti ? 'show' : ''}`} >
                                <li className={`sidebar-item ${isLinkActive('/invoiceUsBank') ? 'active' : ''}`}>
                                  <NavLink to="/invoiceUsBank"
                                    className={`sidebar-link ${isLinkActive('/invoiceUsBank') ? 'active' : ''}`}
                                  > USA Bank </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/invoiceInBank') ? 'active' : ''}`}>
                                  <NavLink to="/invoiceInBank"
                                    className={`sidebar-link ${isLinkActive('/invoiceInBank') ? 'active' : ''}`}
                                  > Indian Bank </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/invoiceRegType') ? 'active' : ''}`}>
                                  <NavLink to="/invoiceRegType"
                                    className={`sidebar-link ${isLinkActive('/invoiceRegType') ? 'active' : ''}`}
                                  > Registration Type </NavLink>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>

                        <li className={`sidebar-item ${adminAbstractReceiptClass || programManagerClassMulti || reviewersClassMulti ? 'active' : ''}`}>
                          <NavLink data-bs-target="#abstract" data-bs-toggle="collapse"
                            className={`sidebar-link ${adminAbstractReceiptClass ? 'active' : ''}`}
                            aria-expanded={adminAbstractReceiptClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Abstract Receipt</span>
                          </NavLink>
                          <ul id="abstract" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${adminAbstractReceiptClass || programManagerClassMulti || reviewersClassMulti ? 'show' : ''}`}
                          >
                            <li className="sidebar-item">
                              <NavLink data-bs-target="#programManagerMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${programManagerClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={programManagerClassMulti ? 'true' : 'false'}
                              >
                                Conference Manager</NavLink>
                              <ul id="programManagerMulti" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${programManagerClassMulti ? 'show' : ''}`} >
                                <li className={`sidebar-item ${isLinkActive('/pendingProgramManager') ? 'active' : ''}`}>
                                  <NavLink to="/pendingProgramManager"
                                    className={`sidebar-link ${isLinkActive('/pendingProgramManager') ? 'active' : ''}`}
                                  > Pending </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/approvedProgramManager') ? 'active' : ''}`}>
                                  <NavLink to="/approvedProgramManager"
                                    className={`sidebar-link ${isLinkActive('/approvedProgramManager') ? 'active' : ''}`}
                                  > Approved </NavLink>
                                </li>
                               
                              </ul>
                            </li>

                            <li className="sidebar-item">
                              <NavLink data-bs-target="#reviewersMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${reviewersClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={reviewersClassMulti ? 'true' : 'false'}
                              >
                                Reviewers</NavLink>
                              <ul id="reviewersMulti" data-bs-parent="#sidebar2"
                                className={`sidebar-dropdown list-unstyled collapse ${reviewersClassMulti ? 'show' : ''}`} >
                                <li className={`sidebar-item ${isLinkActive('/pendingReviewers') ? 'active' : ''}`}>
                                  <NavLink to="/pendingReviewers"
                                    className={`sidebar-link ${isLinkActive('/pendingReviewers') ? 'active' : ''}`}
                                  > Pending </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/approvedReviewers') ? 'active' : ''}`}>
                                  <NavLink to="/approvedReviewers"
                                    className={`sidebar-link ${isLinkActive('/approvedReviewers') ? 'active' : ''}`}
                                  > Approved </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/allReviewers') ? 'active' : ''}`}>
                                  <NavLink to="/allReviewers"
                                    className={`sidebar-link ${isLinkActive('/allReviewers') ? 'active' : ''}`}
                                  > All Reviewers </NavLink>
                                </li>         
                              </ul>
                            </li>

                            <li className="sidebar-item">
                              <NavLink data-bs-target="#abstractMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${adminAbstractReceiptClass ? 'active' : 'collapsed'}`}
                                aria-expanded={adminAbstractReceiptClass ? 'true' : 'false'}
                              >
                                Configurations</NavLink>
                              <ul id="abstractMulti" data-bs-parent="#sidebar3"
                                className={`sidebar-dropdown list-unstyled collapse ${adminAbstractReceiptClass ? 'show' : ''}`} >
                                  <li className={`sidebar-item ${isLinkActive('/abstractType') ? 'active' : ''}`}>
                                  <NavLink to="/abstractType"
                                    className={`sidebar-link ${isLinkActive('/abstractType') ? 'active' : ''}`}
                                  > Abstract Type </NavLink>
                                 </li>
                                  <li className={`sidebar-item ${isLinkActive('/abCategory') ? 'active' : ''}`}>
                                  <NavLink to="/abCategory"
                                    className={`sidebar-link ${isLinkActive('/abCategory') ? 'active' : ''}`}
                                  > Abstract Category </NavLink>
                                 </li>                                                       
                              </ul>
                            </li>

                          </ul>
                       </li>
                        

                        <li className="sidebar-header">General Configuration</li>
                        <li className={`sidebar-item ${defaultSetupClass ? 'active' : ''}`}>
                        <NavLink data-bs-target="#defaultSetupClass" data-bs-toggle="collapse"
                          className={`sidebar-link ${defaultSetupClass ? 'active' : ''}`}
                          aria-expanded={ defaultSetupClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle"> Default Setup </span>        
                        </NavLink>
                        <ul id="defaultSetupClass" data-bs-parent="#sidebar"
                          className={`sidebar-dropdown list-unstyled collapse ${defaultSetupClass ? 'show' : ''}`}
                        >
                          <li className={`sidebar-item ${isLinkActive('/esSubjectType') ? 'active' : ''}`}>
                            <NavLink className="sidebar-link" to="/esSubjectType" > Subject Setup </NavLink>
                          </li>
                          <li className={`sidebar-item ${isLinkActive('/esSubdomainType') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/esSubdomainType"> Subdomain Setup </NavLink>
                          </li>
                          <li className={`sidebar-item ${isLinkActive('/esVenue') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/esVenue"> Venue Setup </NavLink>
                          </li>
                          <li className={`sidebar-item ${isLinkActive('/esSeriesType') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/esSeriesType"> Series Setup </NavLink>
                          </li>                   
                          <li className={`sidebar-item ${isLinkActive('/esCountries') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/esCountries"> Countries Setup </NavLink>
                          </li>
                        </ul>
                        </li>

                        <li className={`sidebar-item ${cmsUserCreationFormsClass? "active":""}`}>
                          <NavLink className="sidebar-link" to="/cmsUser">
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle">CMS Login Configuration</span>
                          </NavLink>
                        </li>

                         <li className={`sidebar-item ${seoConfigClass ? 'active' : ''}`}>
                        <NavLink data-bs-target="#seoConfigClass" data-bs-toggle="collapse"
                          className={`sidebar-link ${seoConfigClass ? 'active' : ''}`}
                          aria-expanded={ seoConfigClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle">Seo Config</span>        
                        </NavLink>
                        <ul id="seoConfigClass" data-bs-parent="#sidebar"
                          className={`sidebar-dropdown list-unstyled collapse ${seoConfigClass ? 'show' : ''}`}
                        >
                          <li className={`sidebar-item ${isLinkActive('/metaTags') ? 'active' : ''}`}>
                            <NavLink className="sidebar-link" to="/metaTags" > Meta Tag Pages </NavLink>
                          </li>
                          <li className={`sidebar-item ${isLinkActive('/seoContextPage') ? 'active' : ''}`}>
                            <NavLink className="sidebar-link" to="/seoContextPage" > SEO Context Page </NavLink>
                          </li>
                        </ul>
                        </li>
                         
                       
                      </>
                    ) : null}

                    {myRole() === 'event' ? (
                      <>
                      <li className={`sidebar-item ${dashboardClass? "active":""}`}>
                          <NavLink className="sidebar-link" to="/dashboard">
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Dashboard</span>
                          </NavLink>
                        </li>
                      <li className="sidebar-header">Conference Leads</li>
                        <li className={`sidebar-item ${emleadsFormsClass ? 'active' : ''}`}>
                        <NavLink data-bs-target="#emconferenceLeads" data-bs-toggle="collapse"
                          className={`sidebar-link ${emleadsFormsClass ? 'active' : ''}`}
                          aria-expanded={ emleadsFormsClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle">Leads Forms</span>        
                        </NavLink>
                        <ul id="emconferenceLeads" data-bs-parent="#sidebar"
                          className={`sidebar-dropdown list-unstyled collapse ${emleadsFormsClass ? 'show' : ''}`}
                        >
                        <li className={`sidebar-item ${isLinkActive('/emabstract') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/emabstract" > Abstract </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/embrochure') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/embrochure" > Brochure </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/emcontact') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/emcontact" > Contact </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/empastconfProceedingsLists') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/empastconfProceedingsLists" > Proceedings </NavLink>
                        </li>
                        </ul>
                        </li>
                        <li className={`sidebar-item ${emrevenueFormsClass ? 'active' : ''}`}>
                        <NavLink data-bs-target="#emRevenueLeads" data-bs-toggle="collapse"
                          className={`sidebar-link ${emrevenueFormsClass ? 'active' : ''}`}
                          aria-expanded={ emrevenueFormsClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-file"></i>
                            <span className="align-middle">Revenue Forms</span>        
                        </NavLink>
                        <ul id="emRevenueLeads" data-bs-parent="#sidebar"
                          className={`sidebar-dropdown list-unstyled collapse ${emrevenueFormsClass ? 'show' : ''}`}
                        >
                        <li className={`sidebar-item ${isLinkActive('/emregistration') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/emregistration" > Registration </NavLink>
                        </li>
                        <li className={`sidebar-item ${isLinkActive('/emselfRegistration') ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/emselfRegistration" > Self Registration </NavLink>
                        </li>
                        </ul>
                        </li>

                        <li className="sidebar-header">Receipt Generation</li>
                          <li className={`sidebar-item ${abstractReceiptClass || abstractConfigClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#abstractReceiptClass" data-bs-toggle="collapse"
                            className={`sidebar-link ${abstractReceiptClass ? 'active' : ''}`}
                            aria-expanded={abstractReceiptClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Abstract Receipt</span>
                          </NavLink>
                          <ul id="abstractReceiptClass" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${abstractReceiptClass || abstractConfigClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/abstractReceipt') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/abstractReceipt" > Abstract Receipt </NavLink>
                            </li>
                           
                            <li className="sidebar-item">
                              <NavLink
                                data-bs-target="#abstractConfigClass" data-bs-toggle="collapse"
                                className={`sidebar-link ${abstractConfigClass ? 'active' : 'collapsed'}`}
                                aria-expanded={abstractConfigClass ? 'true' : 'false'}
                              > Configuration </NavLink>
                              <ul id="abstractConfigClass" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${abstractConfigClass ? 'show' : ''}`}
                              >
                                <li className={`sidebar-item ${isLinkActive('/programManager') ? 'active' : ''}`}>
                                  <NavLink to="/programManager"
                                    className={`sidebar-link ${isLinkActive('/programManager') ? 'active' : ''}`}
                                  > Conference Manager </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/abReviewers') ? 'active' : ''}`}>
                                  <NavLink to="/abReviewers"
                                    className={`sidebar-link ${isLinkActive('/abReviewers') ? 'active' : ''}`}
                                  > Reviewers </NavLink>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                       
                        <li className={`sidebar-item ${paymentReceipt ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/paymentReceipt">
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Payment Receipt Form</span>
                          </NavLink>
                        </li>             
                        
                        <li className={`sidebar-item ${invoiceReceipt ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/invoiceReceipt">
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Invoice Receipt Form</span>
                          </NavLink>
                        </li>  
                        
                        <li className={`sidebar-item ${refund ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/refund">
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Refund Form</span>
                          </NavLink>
                        </li>
                        <li className="sidebar-header">Conference Management</li>
                        <li className={`sidebar-item ${accommodation ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/accommodation">
                            <i className="align-middle me-2 far fa-fw fa-file"></i>
                            <span className="align-middle">Accommodation Form</span>
                          </NavLink>
                        </li>                                                        
                        <li className="sidebar-item py-3"></li>
                      </>
                    ) : null}

                     {myRole() === 'finance' ? (
                      <>
                        <li className={`sidebar-item ${revenueClass ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/revenue">
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Revenue</span>
                          </NavLink>
                        </li>                        
                        
                        <li className="sidebar-item py-3"></li>
                      </>
                    ) : null}

                    {myRole() === 'management' ? (
                      <>
                         <li className="sidebar-header">PDF Generation</li>
                        <li className={`sidebar-item ${mgmtPaymentReceiptClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#mgmtPaymentReceipt" data-bs-toggle="collapse"
                            className={`sidebar-link ${mgmtPaymentReceiptClass ? 'active' : ''}`}
                            aria-expanded={mgmtPaymentReceiptClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Payment Receipt</span>
                          </NavLink>
                          <ul id="mgmtPaymentReceipt" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${mgmtPaymentReceiptClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/mgmtPaymentReceiptReceived') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtPaymentReceiptReceived" > Received Receipt </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtPaymentReceiptGenerated') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtPaymentReceiptGenerated" > Generated Receipt </NavLink>
                            </li>
                            <li className="sidebar-item">
                              <NavLink
                                data-bs-target="#mgmtpaymentReceiptMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${mgmtpaymentReceiptClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={mgmtpaymentReceiptClassMulti ? 'true' : 'false'}
                              > Configuration </NavLink>
                              <ul id="mgmtpaymentReceiptMulti" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${mgmtpaymentReceiptClassMulti ? 'show' : ''}`}
                              >
                                <li className={`sidebar-item ${isLinkActive('/mgmtPrCurrencyType') ? 'active' : ''}`}>
                                  <NavLink to="/mgmtPrCurrencyType"
                                    className={`sidebar-link ${isLinkActive('/mgmtPrCurrencyType') ? 'active' : ''}`}
                                  > Currency Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtPrEventType') ? 'active' : ''}`}>
                                  <NavLink to="/mgmtPrEventType"
                                    className={`sidebar-link ${isLinkActive('/mgmtPrEventType') ? 'active' : ''}`}
                                  > Event Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtPrOccupancyType') ? 'active' : ''}`}>
                                  <NavLink to="/mgmtPrOccupancyType"
                                    className={`sidebar-link ${isLinkActive('/mgmtPrOccupancyType') ? 'active' : ''}`}
                                  > Occupancy Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtPrPaymentType') ? 'active' : ''}`}>
                                  <NavLink
                                    to="/mgmtPrPaymentType"
                                    className={`sidebar-link ${isLinkActive('/mgmtPrPaymentType') ? 'active' : ''}`}
                                  > Payment Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtPrRegistrationType') ? 'active' : ''}`}>
                                  <NavLink
                                    to="/mgmtPrRegistrationType"
                                    className={`sidebar-link ${isLinkActive('/mgmtPrRegistrationType') ? 'active' : ''}`}
                                  > Registration Type </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtPrRegistrationCategory') ? 'active' : ''}`}>
                                  <NavLink
                                    to="/mgmtPrRegistrationCategory"
                                    className={`sidebar-link ${isLinkActive('/mgmtPrRegistrationCategory') ? 'active' : ''}`}
                                  > Registration Category </NavLink>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>     

                        <li className={`sidebar-item ${mgmtInvoiceReceiptClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#mgmtInvoice" data-bs-toggle="collapse"
                            className={`sidebar-link ${mgmtInvoiceReceiptClass ? 'active' : ''}`}
                            aria-expanded={mgmtInvoiceReceiptClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Invoice Receipt</span>
                          </NavLink>
                          <ul id="mgmtInvoice" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${mgmtInvoiceReceiptClass ? 'show' : ''}`}
                          >

                            <li className={`sidebar-item ${isLinkActive('/mgmtInvoiceReceiptReceived') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtInvoiceReceiptReceived"> Received Receipt </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtInvoiceReceiptGenerated') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtInvoiceReceiptGenerated"> Generated Receipt </NavLink>
                            </li>
                            <li className="sidebar-item">
                              <NavLink data-bs-target="#mgmtInvoiceReceiptMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${mgmtInvoiceReceiptClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={mgmtInvoiceReceiptClassMulti ? 'true' : 'false'}
                              >
                                Configuration </NavLink>
                              <ul id="mgmtInvoiceReceiptMulti" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${mgmtInvoiceReceiptClassMulti ? 'show' : ''}`} >
                                <li className={`sidebar-item ${isLinkActive('/mgmtInvoiceUsBank') ? 'active' : ''}`}>
                                  <NavLink to="/mgmtInvoiceUsBank"
                                    className={`sidebar-link ${isLinkActive('/mgmtInvoiceUsBank') ? 'active' : ''}`}
                                  > USA Bank </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtInvoiceInBank') ? 'active' : ''}`}>
                                  <NavLink to="/mgmtInvoiceInBank"
                                    className={`sidebar-link ${isLinkActive('/mgmtInvoiceInBank') ? 'active' : ''}`}
                                  > Indian Bank </NavLink>
                                </li>
                                <li className={`sidebar-item ${isLinkActive('/mgmtInvoiceRegType') ? 'active' : ''}`}>
                                  <NavLink to="/mgmtInvoiceRegType"
                                    className={`sidebar-link ${isLinkActive('/mgmtInvoiceRegType') ? 'active' : ''}`}
                                  > Registration Type </NavLink>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>           

                        <li className="sidebar-header">Conference Management</li>
                        <li className={`sidebar-item ${mgmtAccommodationStatusClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#mgmtConferenceManagement" data-bs-toggle="collapse"
                            className={`sidebar-link ${mgmtAccommodationStatusClass ? 'active' : ''}`}
                            aria-expanded={mgmtAccommodationStatusClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 fas fa-fw fa-directions"></i>
                            <span className="align-middle">Accommodation Status</span>
                          </NavLink>
                          <ul id="mgmtConferenceManagement" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${mgmtAccommodationStatusClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/mgmtPaidAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtPaidAccommodation" > Paid </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtFreeAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtFreeAccommodation" > Free </NavLink>
                            </li>
                          </ul>
                        </li>
                        
                          <li className={`sidebar-item ${mgmtAccommodationClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#mgmtAccommodation" data-bs-toggle="collapse"
                            className={`sidebar-link ${mgmtAccommodationClass ? 'active' : ''}`}
                            aria-expanded={mgmtAccommodationClass ? 'true' : 'false'}
                          >
                            <i className="align-middle me-2 far fa-fw fa-file-pdf"></i>
                            <span className="align-middle">Accommodation</span>
                          </NavLink>
                          <ul id="mgmtAccommodation" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${mgmtAccommodationClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/mgmtPendingAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtPendingAccommodation" > Pending Accommodation </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtStagingAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtStagingAccommodation" > Staging Accommodation </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtVerifiedAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtVerifiedAccommodation" > Verified Accommodation </NavLink>
                            </li>                
                             <li className={`sidebar-item ${isLinkActive('/mgmtCancelledAccommodation') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtCancelledAccommodation" > Cancelled Accommodation </NavLink>
                            </li>
                            <li className="sidebar-item">
                              <NavLink
                                data-bs-target="#mgmtAccommodationSetupMulti" data-bs-toggle="collapse"
                                className={`sidebar-link ${mgmtAccommodationSetupClassMulti ? 'active' : 'collapsed'}`}
                                aria-expanded={mgmtAccommodationSetupClassMulti ? 'true' : 'false'}
                              > Configuration </NavLink>
                              <ul id="mgmtAccommodationSetupMulti" data-bs-parent="#sidebar1"
                                className={`sidebar-dropdown list-unstyled collapse ${mgmtAccommodationSetupClassMulti ? 'show' : ''}`}
                              >
                                <li className={`sidebar-item ${isLinkActive('/accommodationSetup') ? 'active' : ''}`}>
                                  <NavLink to="/accommodationSetup"
                                    className={`sidebar-link ${isLinkActive('/accommodationSetup') ? 'active' : ''}`}
                                  > Accommodation Setup </NavLink>
                                </li>
                                
                              </ul>
                            </li>
                          </ul>
                        </li>    
                          
                        <li className="sidebar-header">Revenue Management</li>
                        <li className={`sidebar-item ${mgmtTransactionStatus ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/mgmtTransactionStatus">
                            <i className="align-middle me-2 fas fa-fw fa-list"></i>
                            <span className="align-middle">Transaction Status</span>
                          </NavLink>
                        </li>
                        <li className={`sidebar-item ${mgmtPaypalTransactions ? 'active' : ''}`}>
                          <NavLink className="sidebar-link" to="/mgmtPaypalTransactions">
                            <i className="align-middle me-2 fas fa-fw fa-list"></i>
                            <span className="align-middle">Paypal Transactions</span>
                          </NavLink>
                        </li>
                        <li className={`sidebar-item ${mgmtRevenueStatusClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#mgmtRevenueStatus" data-bs-toggle="collapse"
                            className={`sidebar-link ${mgmtRevenueStatusClass ? 'active' : ''}`}
                            aria-expanded={mgmtRevenueStatusClass ? 'true' : 'false'}>

                            <i className="align-middle me-2 fas fa-fw fa-dollar-sign"></i>
                            <span className="align-middle">Revenue Status</span>
                          </NavLink>
                          <ul id="mgmtRevenueStatus" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${mgmtRevenueStatusClass ? 'show' : ''}`}
                          >

                            <li className={`sidebar-item ${isLinkActive('/mgmtRevenueAll') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtRevenueAll" > All Revenue </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtRevenueConference') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtRevenueConference" > Conference Revenue </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtRevenueWebinar') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtRevenueWebinar" > Webinar Revenue </NavLink>
                            </li>
                          </ul>
                        </li>
                        <li className={`sidebar-item ${mgmtRefundStatusClass ? 'active' : ''}`}>
                          <NavLink data-bs-target="#mgmtRefundStatus" data-bs-toggle="collapse"
                            className={`sidebar-link ${mgmtRefundStatusClass ? 'active' : ''}`}
                            aria-expanded={mgmtRefundStatusClass ? 'true' : 'false'}>

                            <i className="align-middle me-2 fas fa-fw fa-directions"></i>
                            <span className="align-middle">Refund Status</span>
                          </NavLink>
                          <ul id="mgmtRefundStatus" data-bs-parent="#sidebar"
                            className={`sidebar-dropdown list-unstyled collapse ${mgmtRefundStatusClass ? 'show' : ''}`}
                          >
                            <li className={`sidebar-item ${isLinkActive('/mgmtRefundApproved') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtRefundApproved" > Approved Refunds </NavLink>
                            </li>
                            <li className={`sidebar-item ${isLinkActive('/mgmtRefundPending') ? 'active' : ''}`}>
                              <NavLink className="sidebar-link" to="/mgmtRefundPending" > Pending Refunds </NavLink>
                            </li>
                          </ul>
                        </li>
                        
                        <li className="sidebar-item py-3"></li>
                      </>
                    ) : null}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;